import { Grid } from '@material-ui/core';
import React from 'react';

export const GridItem = ({ children, ...rest }) => {
  return (
    <Grid item xs={12} {...rest}>
      {children}
    </Grid>
  )
}